module.exports = __webpack_public_path__ + "static/media/webcomponents-published-blue.454d793f.svg";